export default __webpack_public_path__ + "static/media/Gallery-1.dcdf7776.png";